import { render, staticRenderFns } from "./CirclePercent.vue?vue&type=template&id=21264922&scoped=true&"
import script from "./CirclePercent.vue?vue&type=script&lang=ts&"
export * from "./CirclePercent.vue?vue&type=script&lang=ts&"
import style0 from "./CirclePercent.vue?vue&type=style&index=0&id=21264922&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21264922",
  null
  
)

export default component.exports